import { render } from "./InitialWhatsappMessageConfig.vue?vue&type=template&id=51f9f454&scoped=true&ts=true"
import script from "./InitialWhatsappMessageConfig.vue?vue&type=script&lang=ts"
export * from "./InitialWhatsappMessageConfig.vue?vue&type=script&lang=ts"

import "./InitialWhatsappMessageConfig.vue?vue&type=style&index=0&id=51f9f454&scoped=true&lang=css"
import "./InitialWhatsappMessageConfig.vue?vue&type=style&index=1&id=51f9f454&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51f9f454"]])

export default __exports__